/* unplugin-vue-components disabled */import script from "./AccountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountManage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__